import Link from "next/link";
import Style from "@/lib/style";

type Props = {
  programName: string;
};

export default function FooterPrograms(props: Props) {
  const { programName } = props;
  const matchedStyle = Style.find(style => style.title === programName);

  const getImages = (programName: string): {
    circlesStyle?: string;
  } => {
    switch(programName) {
      case 'basico':
        return {
          circlesStyle: "-top-[203px] left-0 rotate-180", 
        };
      case 'medio':
        return {
          circlesStyle: "-top-[217px] left-0 rotate-180 scale-x-[-1]",
        };
      case 'profesional':
        return {
          circlesStyle: "-top-[208px] left-0",
        };
      case 'panaderia-y-pasteleria':
        return {
          circlesStyle: "-top-[217px] left-0 rotate-180 scale-x-[-1]",
        };
      default:
        return {
          circlesStyle: "",
        };
    }
  };


  return (
    <section>
      <div className="relative bg-dark-light w-full py-8 text-white">
        {matchedStyle && matchedStyle.images && (
          <div>
            <img src={matchedStyle.images[0].line} className={`${matchedStyle.images[0].lineStyle} hidden md:block absolute rotate-180`} alt="Line"/>
            <img src={matchedStyle?.images[0].circles} className={`hidden md:block absolute ${getImages(programName).circlesStyle} `} alt="Line"/>
          </div>
        )}
        <div className="relative flex justify-center items-center">
          <img src="/images/logos/escudo.svg" className="absolute h-32 w-32 -top-10 transform -translate-y-1/2" alt="Escudo"/>
        </div>
        <div className="mt-4 flex justify-center py-16">
          <div className="flex flex-wrap gap-6 text-center justify-center font-thin max-w-xs md:max-w-sm">
            <p className="text-md md:text-lg">
              © {new Date().getFullYear()} Amura Centro Culinario S.R.L. Llorente de Tibás. San José, Costa Rica.
            </p>
            <Link href="/politica-de-privacidad" className="font-bold hover:text-gray-300">Política de Privacidad</Link>
          </div>
        </div>
      </div>
    </section>
  );
}